var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPublic = function SvgPublic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1z73i75kaa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.334 8.333 8.334S18.333 14.6 18.333 10 14.6 1.667 10 1.667zM3.333 10c0-.508.067-1.008.175-1.483L7.492 12.5v.834c0 .916.75 1.666 1.666 1.666v1.609C5.883 16.192 3.333 13.392 3.333 10zm11.575 4.5a1.66 1.66 0 0 0-1.583-1.166h-.833v-2.5a.836.836 0 0 0-.834-.834h-5V8.334h1.667a.836.836 0 0 0 .833-.834V5.834h1.667c.917 0 1.667-.75 1.667-1.667v-.342A6.67 6.67 0 0 1 16.666 10a6.66 6.66 0 0 1-1.758 4.5z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1z73i75kaa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPublic;